import angular from 'angular';
import MediaUsage from './MediaUsage';

export default angular.module('cms.creator.image.url.filter',[]).filter('imageUrl', ImageUrlFilter).name;

function ImageUrlFilter() {

    let build = function(image, width = 600, defaultValue = ''){

        if(typeof image === 'undefined') {
            return defaultValue;
        }

        return new MediaUsage(image, width, 0).getImgUrl();

    };

    return build;
}



// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/ImageUrlFilter.js